module.exports = __webpack_public_path__ + "static/media/soccer.3d34556d.jpg";